import './App.css';
import { createBrowserRouter, RouterProvider } from 'react-router';
import Home from './views/Home';
import Report from './views/Report';
import TermsOfService from './views/TermsOfService';
import PrivacyPolicy from './views/PrivacyPolicy';

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/report/:guid",
    element: <Report />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfService />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  }
]);

function App() {
  return (
    <RouterProvider router={router} />
  );
}

export default App;